import { Injectable } from "@angular/core";
import { IID_GISFO_WORKORDER } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDGisfoWorkorderQuery } from "./iidGisfoWorkorder.query";
import { IIDGisfoWorkorderStore } from "./iidGisfoWorkorder.store";
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: "root",
})
@InterfaceDataService(InterfaceName.GISFO_WORKORDER)
export class IIDGisfoWorkorderService extends CrudService<IID_GISFO_WORKORDER, IIDGisfoWorkorderStore, IIDGisfoWorkorderQuery> {
  constructor(
    protected store: IIDGisfoWorkorderStore,
    public query: IIDGisfoWorkorderQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(Topics.IID_GISFO_WORKORDER, store, query, actionService, updateStrategy);
  }
}
